import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Radio from '@material-ui/core/Radio';
import useStyles from './styles';

function Modality() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const delivery = 0;
  const drive = 1;
  const local = 2;

  const { company } = useSelector(state => state.data);
  const { adresses } = useSelector(state => state.adresses);
  const { modality } = useSelector(state => state.order.order);

  useEffect(() => {
    if (!company.delivery && modality !== 2) {
      dispatch({
        type: '@order/CHANGE_MODALITY',
        data: {
          adresses,
          modality: 2,
        },
      });
    }
  }, [modality]);

  const handleChange = e => {
    const value = Number(e.target.value);
    dispatch({
      type: '@order/CHANGE_MODALITY',
      data: {
        adresses,
        modality: value,
      },
    });
  };

  return company && (company.delivery || company.auto) ? (
    <ul className={classes.modality}>
      {company && company.delivery && (
        <>
          <li>
            <Radio
              checked={delivery === modality}
              onChange={handleChange}
              value={delivery}
              color="default"
              name="delivery"
            />
            <span>Entrega</span>
          </li>
          <li>
            <Radio
              checked={drive === modality}
              onChange={handleChange}
              value={drive}
              color="default"
              name="delivery"
            />
            <span>Retirada</span>
          </li>
        </>
      )}

      {company && company.auto && (
        <li>
          <Radio
            checked={local === modality}
            onChange={handleChange}
            value={local}
            color="default"
            name="delivery"
          />
          <span>Local</span>
        </li>
      )}
    </ul>
  ) : null;
}

export default Modality;
